import xhr from '../../Xhr';

const API = (id, schedule) => ({
  user: {
    info: {
      url: process.env.REACT_APP_API + `/v1/user/${id}/user_info`,
      method: 'GET'
    },
    mail: {
      url: process.env.REACT_APP_API_SERVER + `/v1/vdn/${id}`,
      method: 'GET'
    },
    node: {
      url: process.env.REACT_APP_API + `/v1/user/${id}/nodeinfo`,
      method: 'GET'
    },
    realName: {
      url: process.env.REACT_APP_API_SERVER + `/v1/vdn/${id}/real_name_auth?username=${localStorage.getItem('ShadowFog_username')}`,
      method: 'GET'
    },
    changeNode: {
      url: `https://scheduler.ablive.net:10035/v2/${id}/scheduler`,
      method: 'GET'
    },
    checkSchedule: {
      url: process.env.REACT_APP_API + `/v1/user/${id}/muti_channel`,
      method: 'GET'
    },
    changeSchedule: {
      url: process.env.REACT_APP_API + `/v1/user/${id}/schedule?type=${schedule}`,
      method: 'POST'
    }
  }
})

export const fetchUserInfo = () => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid')).user.info,
    action: 'USER/INFO'
  })
}
export const fetchMail = () => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid')).user.mail,
    action: 'USER/MAIL'
  })
}
export const fetchUserNode = () => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid')).user.node,
    action: 'USER/NODE'
  })
}
export const fetchRealName = () => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid')).user.realName,
    action: 'USER/REALNAME'
  })
}
export const changeNode = ({...event}) => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid')).user.changeNode,
    action: 'USER/CHANGENODE',
    event
  })
}
export const checkSchedule = () => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid')).user.checkSchedule,
    action: 'USER/CHECKSCHEDULE',
  })
}
export const changeSchedule = ({data, ...event}) => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid'), data).user.changeSchedule,
    action: 'USER/CHANGESCHEDULE',
    data,
    event
  })
}

export const showModal = () => ({
  type: 'SHOW_MODAL'
})

export const hideModal = () => ({
  type: 'HIDE_MODAL'
})


// WEBPACK FOOTER //
// ./src/modules/user/actions.js